/**
 * BSS B2Bの計算後合計を使って、カートページの送料無料案内を更新する。
 *
 * ShopifyのLiquidと /cart.js にはBSSの画面上の値引きが反映されないため、
 * BSSが小計を描画した後にクライアント側で判定する。
 */
(function () {
  'use strict';

  if (window.freeShippingNoticeInitialized) return;
  window.freeShippingNoticeInitialized = true;

  var CONTAINER_SELECTOR = '[data-free-shipping-container]';
  var NOTICE_SELECTOR = '[data-free-shipping-notice]';
  var EXCLUDED_ITEM_SELECTOR = '[data-free-shipping-excluded-item]';
  var BSS_ACTIVE_TOTAL_SELECTOR = '[bss-b2b-cart-total-price][bss-b2b-cart-price-active]';
  var FALLBACK_DELAY = 8000;
  var POLL_INTERVAL = 100;
  var POLL_LIMIT = 100;

  var hookRegistered = false;
  var bssCalculationObserved = false;
  var updateTimer = null;
  var fallbackTimer = null;
  var pollCount = 0;
  var footerObserver = null;

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function getContainers() {
    return document.querySelectorAll(CONTAINER_SELECTOR);
  }

  function formatYenFromCents(cents) {
    var yen = Math.max(0, Math.ceil(cents / 100));
    return new Intl.NumberFormat('ja-JP').format(yen) + '円';
  }

  function setNoticeState(container, state, html) {
    var notice = container.querySelector(NOTICE_SELECTOR);
    if (!notice) return;

    notice.classList.remove('is-pending', 'is-achieved', 'is-unavailable');
    if (state) notice.classList.add('is-' + state);
    if (notice.innerHTML !== html) notice.innerHTML = html;

    container.setAttribute('aria-busy', state === 'pending' ? 'true' : 'false');
    container.dataset.freeShippingState = state;
  }

  function markPending() {
    getContainers().forEach(function (container) {
      setNoticeState(container, 'pending', '送料無料条件を計算しています…');
    });

    bssCalculationObserved = false;
    startFallbackTimer();
  }

  function getBssCartItem(key) {
    var bss = window.BSS_B2B;
    var storage = bss && bss.storage && bss.storage.cartStorage;
    if (!storage || typeof storage.get !== 'function') return null;

    try {
      return storage.get(key) || null;
    } catch (error) {
      return null;
    }
  }

  function getBssUnitPrice(item) {
    if (!item) return null;

    var bss = window.BSS_B2B;
    var getModifyPrice = bss && bss.utils && bss.utils.getModifyPrice;
    if (typeof getModifyPrice === 'function') {
      try {
        var modifiedPrice = toNumber(getModifyPrice(item, item.bssB2bShowPriceKey));
        if (modifiedPrice !== null) return modifiedPrice;
      } catch (error) {
        // BSS内部APIが変更された場合は、現在の価格フィールドへフォールバックする。
      }
    }

    var priceFields = [
      'bssB2BPriceAfterTD',
      'bssB2BPriceAfterDC',
      'bssB2BPriceAfterBogo',
      'bssB2BPriceAfterQB',
      'bssB2BPriceAfterCP',
      'bssB2BPriceAfterPL',
      'original_price',
      'final_price',
      'price',
    ];

    for (var index = 0; index < priceFields.length; index += 1) {
      var price = toNumber(item[priceFields[index]]);
      if (price !== null) return price;
    }

    return null;
  }

  function getExcludedGiftTotal(container) {
    var excludedTotal = 0;

    container.querySelectorAll(EXCLUDED_ITEM_SELECTOR).forEach(function (element) {
      var item = getBssCartItem(element.dataset.cartKey);
      var unitPrice = getBssUnitPrice(item);
      var quantity = item ? toNumber(item.quantity) : null;

      if (unitPrice !== null && quantity !== null) {
        excludedTotal += unitPrice * quantity;
        return;
      }

      // BSSはBXGY適用後価格ではなく元価格を合計するため、同じ元価格を差し引く。
      excludedTotal += toNumber(element.dataset.originalLinePriceCents) || 0;
    });

    return Math.round(excludedTotal);
  }

  function getBssTotal() {
    if (!bssCalculationObserved) return null;

    var bss = window.BSS_B2B;
    var cart = bss && bss.shopData && bss.shopData.cart;
    if (!cart || !Object.prototype.hasOwnProperty.call(cart, 'bss_b2b_total_price')) return null;

    return toNumber(cart.bss_b2b_total_price);
  }

  function formatCartTotal(cents) {
    var bss = window.BSS_B2B;
    if (bss && typeof bss.formatMoney === 'function') {
      try {
        return bss.formatMoney(cents);
      } catch (error) {
        // BSSのフォーマッターを利用できない場合は日本円表記へフォールバックする。
      }
    }

    return '¥' + new Intl.NumberFormat('ja-JP').format(Math.max(0, Math.round(cents / 100)));
  }

  function renderCartTotal(container, applicableTotal) {
    var contents = container.closest('.js-contents') || document.getElementById('main-cart-footer');
    if (!contents) return;

    var totalElements = contents.querySelectorAll(
      '[bss-b2b-cart-total-price], .totals__total-value'
    );
    var formattedTotal = formatCartTotal(applicableTotal);

    totalElements.forEach(function (element) {
      if (element.textContent.trim() !== formattedTotal) {
        element.textContent = formattedTotal;
      }
    });
  }

  function renderFromBssTotal() {
    var bssTotal = getBssTotal();
    if (bssTotal === null) return false;

    var rendered = false;
    getContainers().forEach(function (container) {
      var threshold = toNumber(container.dataset.thresholdCents);
      if (threshold === null) return;

      var applicableTotal = Math.max(0, bssTotal - getExcludedGiftTotal(container));
      var remaining = threshold - applicableTotal;

      renderCartTotal(container, applicableTotal);

      if (remaining > 0) {
        setNoticeState(
          container,
          '',
          'あと <strong>' + formatYenFromCents(remaining) + '</strong> で送料無料です'
        );
      } else {
        setNoticeState(container, 'achieved', '<strong>送料無料が適用されます！</strong>');
      }
      rendered = true;
    });

    if (rendered && fallbackTimer) {
      window.clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }

    return rendered;
  }

  function showUnavailableMessage() {
    getContainers().forEach(function (container) {
      if (container.dataset.freeShippingState !== 'pending') return;
      setNoticeState(container, 'unavailable', '送料無料条件は購入手続き時にご確認ください');
    });
  }

  function startFallbackTimer() {
    if (fallbackTimer) window.clearTimeout(fallbackTimer);
    fallbackTimer = window.setTimeout(showUnavailableMessage, FALLBACK_DELAY);
  }

  function scheduleUpdate(calculationCompleted) {
    if (calculationCompleted) bssCalculationObserved = true;
    if (updateTimer) window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(function () {
      updateTimer = null;
      renderFromBssTotal();
    }, 0);
  }

  function registerBssHook() {
    if (hookRegistered) return true;

    var bss = window.BSS_B2B;
    var custom = bss && bss.custom;
    if (!custom || typeof custom.addAction !== 'function') return false;

    try {
      custom.addAction(
        'custom:cart/showSubtotalPrice',
        function () {
          scheduleUpdate(true);
        },
        1000
      );
      hookRegistered = true;
      return true;
    } catch (error) {
      return false;
    }
  }

  function hasActiveBssTotal() {
    return !!document.querySelector(BSS_ACTIVE_TOTAL_SELECTOR);
  }

  function checkBssState() {
    registerBssHook();

    if (hasActiveBssTotal()) {
      scheduleUpdate(true);
    }
  }

  function observeFooter() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer || footerObserver) return;

    footerObserver = new MutationObserver(function () {
      checkBssState();
    });
    footerObserver.observe(footer, {
      attributes: true,
      attributeFilter: ['bss-b2b-cart-price-active'],
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function subscribeToCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      markPending();
      window.setTimeout(checkBssState, 0);
    });
  }

  function pollForBss() {
    checkBssState();
    pollCount += 1;

    if (hookRegistered || pollCount >= POLL_LIMIT) return;
    window.setTimeout(pollForBss, POLL_INTERVAL);
  }

  function initialize() {
    if (!getContainers().length) return;

    observeFooter();
    subscribeToCartUpdates();
    startFallbackTimer();
    checkBssState();
    pollForBss();
  }

  window.addEventListener('bss_b2b:loadedObserver', checkBssState);
  window.addEventListener('bss_b2b:module:loaded', checkBssState);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
